// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'
import moment from "moment"

import {
  SvgIcon,
  Table,
  Spinner,
  Warning,
  SpanWithData
} from '../../'

import {
  decodeBase64,
  PageNavigationControl
} from '../../../utils'


const QUERY_EMPLOYER_IDENTITY = gql`
  query($id: ID!) {
    employer(id: $id) {
      id
      identity {
        id
      }
    }
  }
`


const QUERY_BULKMESSAGES = gql`
  query($fromIdentityId: UUID!, $audience: ID, $status: String, $createdAtFrom: DateTime, $createdAtTo: DateTime, $scheduledAtFrom: DateTime, $scheduledAtTo: DateTime) {
    bulkmessages(fromIdentity_Id: $fromIdentityId, audience: $audience, status: $status, createdAt_Gte: $createdAtFrom, createdAt_Lte: $createdAtTo, scheduledAt_Gte: $scheduledAtFrom, scheduledAt_Lte: $scheduledAtTo) {
      edges {
        node {
          id
          description
          content
          scheduledAt
          createdAt
          status
          audience {
            id
            name
          }
          messages {
            totalCount
            edges {
              node {
                id
                status
              }
            }
          }
          telegrammessages {
            totalCount
            edges {
              node {
                id
                status
              }
            }
          }
        }
      }
    }
  }
`


class EmployerBulkSMSMessages extends PureComponent {
  static propTypes = {
    employerId: PropTypes.string.isRequired,
    status: PropTypes.string,
    audience: PropTypes.string,
    createdAtFrom: PropTypes.string,
    createdAtTo: PropTypes.string,
    scheduledAtFrom: PropTypes.string,
    scheduledAtTo: PropTypes.string,
    orderBy: PropTypes.string,
    changeSort: PropTypes.func,
    resultsPerPage: PropTypes.number,
    className: PropTypes.string
  }

  static defaultProps = {
    resultsPerPage: 15,
    className: ''
  }

  state = {
    selectedMessage: null,
    replyToMessage: false,
    filterChanged: false,
    pageNav: new PageNavigationControl()
  }

  getTableRows = (messages) => (
    messages.edges.map(({ node: message }) => (
      <tr onClick={() => this.props.history.push(`/employer/${this.props.employerId}/communications/bulk/${message.id}`)} key={`row_${message.id}`}>
        <td>
          {message.description}
        </td>
        <td>
          {message.audience.name}
        </td>
        <td>
          <SpanWithData forField='BulkMessageStatus' searchKey={message.status} />
        </td>
        <td>
          {moment(message.createdAt).format('lll')}
        </td>
        <td>
          {message.scheduledAt
            ? moment(message.scheduledAt).format('lll')
            : '-'
          }
        </td>
        <td>
          {message.messages.totalCount}
        </td>
        <td>
          {message.messages.edges.filter(message => message.node.status === "SENT_AAT").length}
        </td>
        <td>
          {message.telegrammessages.totalCount}
        </td>
        <td>
          {message.telegrammessages.edges.filter(message => message.node.status === "SENT_UPSTREAM").length}
        </td>
      </tr>
    ))
  )

  render() {
    if (this.props.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    // let pageNav = this.state.pageNav
    let columns = ['Description', 'Audience', 'Status', 'Created at', 'Scheduled at', 'SMS Total', 'SMS sent', 'Telegram Total', 'Telegram sent']

    // let messages = this.props.messages
    // let startCursor = messages.pageInfo.startCursor
    // let totalCount = messages.totalCount

    const { status, audience, createdAtFrom, createdAtTo, scheduledAtFrom, scheduledAtTo, className } = this.props
    return (
      <div className={className}>
        <Query query={QUERY_EMPLOYER_IDENTITY} variables={{ id: this.props.match.params.employerId }}>
          {({ loading, error, data }) => {
            if (loading || error) {
              return null
            }

            return (
              <Query
                query={QUERY_BULKMESSAGES}
                variables={{
                  fromIdentityId: decodeBase64(data.employer.identity.id),
                  status,
                  audience,
                  createdAtFrom,
                  createdAtTo,
                  scheduledAtFrom,
                  scheduledAtTo
                }}
                // data will be fetched every 60 seconds
                pollInterval={60000}>
                {({ loading, error, data }) => {
                  if (loading) {
                    return <Spinner type='tail' />
                  }

                  if (error) {
                    return <Warning>Failed to fetch bulk SMS messages</Warning>
                  }

                  if (data.bulkmessages.edges.length === 0) {
                    return (
                      <div className='slds-p-around_medium'>
                        <SvgIcon
                          variant='utility'
                          symbol='info'
                          size='small'
                          colour='light'
                          className='slds-m-right_medium'
                        />
                        No bulk messages
                      </div>
                    )
                  }

                  return (
                    <React.Fragment>
                      <Table
                        columns={columns}
                        rows={this.getTableRows(data.bulkmessages)}
                        objectRows={true}
                        orderBy={this.props.orderBy}
                        changeSort={this.props.changeSort}
                        querySortableColumns={{
                          'Date/Time': {
                            orderByName: 'timestamp'
                          }
                        }}
                      />
                      {/*<PageNavigationButtons
                        onNextClick={() => pageNav.nextPage(this.props.fetchNext)}
                        onPreviousClick={() => pageNav.previousPage(this.props.fetchPrevious)}
                        previousDisabled={pageNav.firstPage}
                        nextDisabled={pageNav.lastPage}
                        startCursor={startCursor}
                        totalCount={totalCount}
                        resultsPerPage={this.props.resultsPerPage}
                        resultsText='messages'
                        onPageNumberClick={pageNumber => this.props.refetch({ cursor: getPageCursor(pageNumber, this.props.resultsPerPage) })}
                        className="slds-p-around_medium slds-float_right"
                      />*/}
                    </React.Fragment>
                  )
                }}
              </Query>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default withRouter(EmployerBulkSMSMessages)



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-bulk-sms-messages/index.js